<template>
    <div class="flex justify-center mt-20">
    <div class="w-full sm:w-7/12">
      <div name="logo" class="w-5/12 flex">
        <img src="/img/TardiniLogo.svg"/>
      </div>
      <div class="m-4 text-sm text-gray-600">
        {{ __('Password dimenticata? Inserisci il tuo username: invieremo il link di reset all email registrata.') }}
    </div>
      <div class="p-8 bg-white rounded shadow-xl">
        <form @submit.prevent="sendEmail">
          <div class="mt-4">
            <div class="block text-sm text-gray-00" for="username" :value="__('Username')"></div>
            <input class="w-full px-2 py-2 text-gray-700 bg-gray-100 rounded" id="username" type="text" name="username"
              v-model="data.username" placeholder="username" required autofocus />
          </div>
          <div class="flex items-center justify-between mt-4">
            <router-link :to="{path: '/login'}" class="cursor-pointer px-4 py-1 text-white font-light tracking-wider bg-gray-900 rounded focus:outline-none">
              {{__('annulla')}}
            </router-link>
            <button class="px-4 py-1 text-white font-light tracking-wider bg-gray-900 rounded focus:outline-none">
              {{ __('invia link') }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
    data() {
        return {
            data: {
                username: undefined
            }
        }
    },
    methods: {
        async sendEmail() {
          await this.storeLogTime(async () => {
            let res = await this.handleCallback(() => this.axios.post('/auth/forgotpassword', this.data), true);
            this.clear();
            if(res)
                this.$router.push({name: 'login'});
            return res;
          });
        },
        clear() {
            this.data.username = undefined;
        }
    }
}
</script>